import { render, staticRenderFns } from "./blog-7.vue?vue&type=template&id=239f2b5e&scoped=true"
import script from "./blog-7.vue?vue&type=script&lang=js"
export * from "./blog-7.vue?vue&type=script&lang=js"
import style0 from "./blog-7.vue?vue&type=style&index=0&id=239f2b5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239f2b5e",
  null
  
)

export default component.exports